<template>
	<div
		ref="trustbox"
		class="trustpilot-widget"
		:data-locale="locale"
		:data-businessunit-id="'59a849e70000ff0005aa1f17'"
		:data-template-id="templateId"
		:data-style-height="height"
		:data-style-width="width"
		data-theme="light"
	></div>
</template>

<script>
export default {
	props: {
		template: {
			type: String,
			default: "large",
		},
		locale: {
			type: String,
			default: "da-Dk",
		},
	},

	data() {
		return {
			templateId: "",
			height: "",
			width: "",
			maxWidth: 0,
		};
	},

	created() {
		this.setTemplate();
		this.setWidth();
	},

	mounted() {
		const trustbox = this.$refs.trustbox;
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(trustbox);
		}
	},

	methods: {
		setWidth() {
			let windowWidth = window.innerWidth;

			if (!this.maxWidth) {
				this.width = "100%";
				return;
			}

			if (windowWidth >= this.maxWidth) {
				this.width = this.maxWidth + "px";
				return;
			}

			this.width = windowWidth + "px";
		},

		setTemplate() {
			switch (this.template) {
				case "score":
					this.templateId = "5419b637fa0340045cd0c936";
					this.height = "22px";
					this.maxWidth = 245;
					break;
				case "star":
					this.templateId = "5419b732fbfb950b10de65e5";
					this.height = "22px";
					this.maxWidth = 310;
					break;
				case "review":
					this.templateId = "5419b6a8b0d04a076446a9ad";
					this.height = "22px";
					this.maxWidth = 295;
					break;
				case "combo":
					this.templateId = "5419b6ffb0d04a076446a9af";
					this.height = "20px";
					this.maxWidth = 510;
					break;
				case "button":
					this.templateId = "5419b757fa0340045cd0c938";
					this.height = "25px";
					this.maxWidth = 140;
					break;
				case "list":
					this.templateId = "539ad60defb9600b94d7df2c";
					this.height = "100%";
					this.maxWidth = 0;
					break;
				default:
					this.templateId = "53aa8807dec7e10d38f59f32";
					this.height = "100%";
					this.maxWidth = 0;
					break;
			}
		},
	},
};
</script>
